import getOffset from '../utils/getOffset'
import withScroll from '../hoc/withScroll'
import onResize from '../utils/onResize'

export default withScroll({
  name: 'timeline',

  erasScroll: [],

  ui: {
    rail: '[js-timeline-rail]',
    current: '[js-timeline-current]',
    currentLine: '[js-timeline-current-line]',
    'eras[]': '[js-timeline-era]',
    years: '[js-timeline-years]',
    mobileLine: '[js-timeline-mobile-line]',
  },

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))
    this.totalSlides = this.el.querySelectorAll('.swiper-slide').length

    // for mobile timeline
    this.configObserver = { attributes: true }
    this.observer = new MutationObserver(this.observerCallback)
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.calc()
    this.manageObserver()
  },

  manageObserver () {
    if (window.innerWidth < 1024) {
      this.el.querySelectorAll('.swiper-slide').forEach(slide => {
        this.observer.observe(slide, this.configObserver)
      })
    } else {
      if (this.observer !== undefined) {
        this.observer.disconnect()
      }
    }
  },

  observerCallback (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.target.classList.contains('swiper-slide-active')) {
        const currentSlide = Array.from(mutation.target.parentNode.children).indexOf(mutation.target)

        this.ui.mobileLine.style.width = `${(100 / (this.totalSlides - 1)) * currentSlide}%`

        if (currentSlide === this.totalSlides - 1) {
          this.ui.mobileLine.parentNode.classList.add('is-end')
        } else {
          this.ui.mobileLine.parentNode.classList.remove('is-end')
        }
      }
    }
  },

  calc () {
    if (window.innerWidth >= 1024) {
      this.offsetTop = getOffset(this.el) - 40
      this.bottom = this.offsetTop + this.el.offsetHeight

      this.offsetTranslate = 108

      this.erasScroll = []

      this.ui.eras.forEach(era => {
        const offsetTop = getOffset(era)

        this.erasScroll.push({
          offsetTop,
          offsetBottom: offsetTop + this.calcEraHeight(era),
        })
      })
    }
  },

  calcEraHeight (era) {
    let height = era.offsetHeight
    let elem = era.nextElementSibling

    while (elem) {
      // If we've reached our match, bail
      if (elem.matches('[js-timeline-era]')) break

      // Otherwise, push it to the siblings array
      height = height + elem.offsetHeight

      // Get the next sibling element
      elem = elem.nextElementSibling
    }

    return height
  },

  onScroll ({ y }) {
    if (window.innerWidth >= 1024) {
      // current point + line
      if (y >= this.offsetTop) {
        let percent = ((y - this.offsetTop) * 100) / (this.bottom - this.offsetTop)

        if (percent > 100) percent = 100

        this.ui.current.style.top = `${percent}%`
        this.ui.currentLine.style.height = `${percent}%`

        // change year based on current infos displayed
        for (let i = 0; i < this.erasScroll.length; i++) {
          if (y + (window.innerHeight * 0.5) >= this.erasScroll[i].offsetTop && y + (window.innerHeight * 0.5) < this.erasScroll[i].offsetBottom) {
            this.ui.years.style.transform = `translateY(-${i * this.offsetTranslate}px)`
            this.el.querySelector('[js-timeline-year].is-active').classList.remove('is-active')
            this.el.querySelector(`[js-timeline-year]:nth-child(${i + 1})`).classList.add('is-active')
            break
          }
        }
      } else {
        this.ui.current.style.top = 0
        this.ui.currentLine.style.height = 0
        this.ui.years.style.transform = 'translateY(0)'
      }
    }
  },
})
